module.exports = __webpack_public_path__ + "img/Logo.3693962b.png";